import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalButton, NavigateLinks } from '@/components';
import { Add as AddIcon } from '@mui/icons-material';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { OfficesTable, SearchBar } from './components';
import { officesPageBreadcrumbs } from './config';
import { useOfficesFilter } from './hooks';

const Offices = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(() => officesPageBreadcrumbs(navigate), []);
  
  const { filter, initialFilter, setFilter } = useOfficesFilter();

  return (
    <section className='w-full h-full flex flex-col gap-6'>
      <NavigateLinks actualPage='Oficinas' breadcrumbs={breadcrumbs} />
      <div className='flex justify-end gap-2.5'>
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={() => navigate('create')}
        >
          <AddIcon />
          Agregar oficina
        </GlobalButton>
      </div>
      <div className='searchBar'>
        <SearchBar
          filter={filter}
          initialFilter={initialFilter}
          search={(updatedFilter) => setFilter(updatedFilter)}
        />
      </div>
      <OfficesTable filter={filter} />
    </section>
  );
};

export default Offices;